import {MappableData} from './MappableData';
import { MappedDataItem } from './MappedDataItem';
import {ReportDataService} from '../../report-data.service';

import {environment} from '../../../environments/environment';

export class ReportingCalendarMap extends MappableData {

  constructor(protected reportService: ReportDataService) {
    super(reportService, 'Reporting Calendar');
    this.mappedData.push(new MappedDataItem(environment.REPORTING_CALENDAR, 'Start Date', 'StartDate'));
    this.mappedData.push(new MappedDataItem(environment.REPORTING_CALENDAR, 'End Date', 'EndDate'));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data/ReportingCalendarMap.ts